var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuditFirm(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5788_3640)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3327 18.3335L1.66602 18.3335",
    stroke: "#28475C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1673 18.3332V4.99984C14.1673 3.42849 14.1673 2.64281 13.6792 2.15466C13.191 1.6665 12.4053 1.6665 10.834 1.6665H9.16732C7.59597 1.6665 6.8103 1.6665 6.32214 2.15466C5.83398 2.64281 5.83398 3.42849 5.83398 4.99984V18.3332",
    stroke: "#28475C",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5007 18.3332V9.58317C17.5007 8.41279 17.5007 7.82759 17.2198 7.40722C17.0982 7.22524 16.9419 7.06899 16.7599 6.94739C16.3396 6.6665 15.7544 6.6665 14.584 6.6665",
    stroke: "#28475C",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 18.3332V9.58317C2.5 8.41279 2.5 7.82759 2.78088 7.40722C2.90248 7.22524 3.05873 7.06899 3.24072 6.94739C3.66109 6.6665 4.24628 6.6665 5.41667 6.6665",
    stroke: "#28475C",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 18.3335V15.8335",
    stroke: "#28475C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33398 4.1665H11.6673",
    stroke: "#28475C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33398 6.6665H11.6673",
    stroke: "#28475C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33398 9.1665H11.6673",
    stroke: "#28475C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33398 11.6665H11.6673",
    stroke: "#28475C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5788_3640"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 3,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuditFirm);
export default __webpack_public_path__ + "static/media/auditFirm.d2857cf8fb9812d1e873db4ceeafe21c.svg";
export { ForwardRef as ReactComponent };